<div class="agpr-viQuestionDetails" [formGroup]="form">
    @let hasQuestionError = form.controls['question'].invalid && (showErrors || form.controls['question'].dirty);
    @let hasAnswerSignalError = form.controls['expectedAnswerSignals'].invalid && (showErrors || form.controls['expectedAnswerSignals'].dirty);

    <agpr-dropdown
        formControlName="dimension"
        [id]="id + '_dimension'"
        [label]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.dimension.label'"
        [options]="dimensionOptions"
        [bindToValue]="true"
    ></agpr-dropdown>

    <div class="agpr-viQuestionDetails-field">
        <agpr-textarea-input
            formControlName="question"
            [id]="id + '_question'"
            [label]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.question.label'"
            [placeholder]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.question.placeholder'"
            [rows]="3"
            [maxLength]="1000"
            [required]="true"
        ></agpr-textarea-input>
        @if (hasQuestionError) {
            <agpr-form-message [id]="id + '_question_error'" [marginBottom]="0">
                {{ 'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.question.error' | localize }}
            </agpr-form-message>
        }
    </div>

    <div class="agpr-viQuestionDetails-field">
        <agpr-textarea-input
            formControlName="answerSignalDraft"
            [id]="id + '_answerSignal'"
            class="agpr-viQuestionDetails-answerSignal-input"
            [label]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.answerSignal.label'"
            [tooltip]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.answerSignal.tooltip'"
            [placeholder]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.answerSignal.placeholder'"
            [rows]="3"
            (keydown)="onAnswerSignalKeydown($event)"
            [required]="true"
        ></agpr-textarea-input>
        <div class="agpr-viQuestionDetails-answerSignal-listContainer">
            @if (form.controls['expectedAnswerSignals'].value?.length) {
                <ul class="agpr-viQuestionDetails-answerSignal-list">
                    @for (signal of form.controls['expectedAnswerSignals'].value; track signal; let i = $index) {
                        <li class="agpr-viQuestionDetails-answerSignal-listItem">
                            <span class="agpr-viQuestionDetails-answerSignal-listItem-text">{{ signal }}</span>
                            <agpr-button
                                [id]="id + '_answerSignal_' + i + '_removeButton'"
                                class="agpr-viQuestionDetails-answerSignal-listItem-button"
                                [style]="buttonTypes.icon"
                                icon="fa-regular fa-duotone fa-square-xmark"
                                tooltip="Core.button.remove"
                                tooltipPosition="left"
                                (click)="removeAnswerSignal(i)"
                            ></agpr-button>
                        </li>
                    }
                </ul>
            } @else {
                <div class="agpr-viQuestionDetails-answerSignal-list-placeholder">
                    {{ 'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.answerSignal.chipPlaceholder' | localize }}
                </div>
            }

        </div>
        @if (hasAnswerSignalError) {
            <agpr-form-message [id]="id + '_answerSignal_error'" [marginBottom]="0">
                {{ 'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.answerSignal.error' | localize }}
            </agpr-form-message>
        }
    </div>

    <div class="agpr-viQuestionDetails-field">
        <div class="agpr-viQuestionDetails-label">
            {{ 'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.questionType.label' | localize }}
            <span
                class="agpr-viQuestionDetails-label-tooltip fa-regular fa-circle-info"
                [agprTooltip]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.questionType.tooltip' | localize"
                aria-hidden="true"
            ></span>
        </div>
        <div class="agpr-viQuestionDetails-radioGroup">
            <agpr-radio
                [id]="id + '_questionType_branded'"
                [name]="id + '_questionType'"
                [label]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.questionType.branded'"
                [value]="true"
                [(ngModel)]="isBranded"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onIsBrandedChange($event)"
            ></agpr-radio>
            <agpr-radio
                [id]="id + '_questionType_unbranded'"
                [name]="id + '_questionType'"
                [label]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.questionType.unbranded'"
                [value]="false"
                [(ngModel)]="isBranded"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onIsBrandedChange($event)"
            ></agpr-radio>
        </div>
    </div>

    <agpr-dropdown
        formControlName="intentType"
        [id]="id + '_intentType'"
        [label]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.intentType.label'"
        [options]="intentTypeOptions"
        [bindToValue]="true"
    ></agpr-dropdown>
</div>
